import { createAction, props } from '@ngrx/store'
import { EntityWiseDataAPIModel, UserDashboardAPIModel } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const load_dashboard_action = createAction(
  `${actionPrefix} load_dashboard_state`,
  props<{ from: Date; to: Date }>()
)

export const load_dashboard_success = createAction(
  `${actionPrefix} load_dashboard_success`,
  props<UserDashboardAPIModel>()
)
export const load_dashboard_failure = createAction(`${actionPrefix} load_dashboard_failure`, props<any>())

export const load_entity_wise_data_action = createAction(
  `${actionPrefix} load_entity_wise_data_action`,
  props<{ companyEntities: string[]; from: Date; to: Date }>()
)

export const load_entity_wise_data_success = createAction(
  `${actionPrefix} load_entity_wise_data_success`,
  props<EntityWiseDataAPIModel>()
)

export const load_entity_wise_data_failure = createAction(`${actionPrefix} load_entity_wise_data_failure`, props<any>())

export const delete_entity_wise_data_action = createAction(`${actionPrefix} delete_entity_wise_data_action`)
